export default __webpack_public_path__ + "static/media/coffe4.1dd56781.png";